import { addToCart } from "../singleProduct/addToCart";
import PubSub from "../../utils/PubSub";

export default function setupProductAddToCart() {
  const addToCartButtons = document.querySelectorAll(
    "button.product-add-to-cart:not([data-initialized])"
  );

  addToCartButtons.forEach((button) => {
    button.setAttribute("data-initialized", "true");

    button.addEventListener("click", async function (e) {
      e.preventDefault();
      e.stopPropagation();

      // Find the closest anchor tag and prevent its navigation
      const parentLink = this.closest("a");
      if (parentLink) {
        parentLink.addEventListener("click", (e) => e.preventDefault(), {
          once: true,
        });
      }

      if (this.disabled) return;

      const productId = this.dataset.productId;
      const formData = new FormData();
      formData.append("product_id", productId);
      formData.append("quantity", "1");

      const currentButton = this;

      const startHandler = () => (currentButton.disabled = true);
      const endHandler = () => (currentButton.disabled = false);
      const successHandler = (response) => {
        PubSub.publish("cart:addItem:success", { data: response.data });

        const cartToggle = document.querySelector("#cart-toggle");
        if (cartToggle) {
          cartToggle.click();
        }
      };

      PubSub.subscribeOnce("fetch:addToCart:start", startHandler);
      PubSub.subscribeOnce("fetch:addToCart:end", endHandler);
      PubSub.subscribeOnce("fetch:addToCart:success", successHandler);

      try {
        await addToCart(formData);
      } catch (error) {
        PubSub.publish("cart:addItem:error", { error });
      }
    });
  });
}
